import { Model } from '@models';

export class OrderState extends Model {
  name: string;
}
